import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class LangUtilService {
  subscription: Subscription;

  constructor(
    private translate: TranslateService,
    private configService: ConfigService
  ) {
  }

  loadUserLanguageOnceAfterLogin(language: string = 'en') {
    this.configService.getLanguageMeta(language).subscribe({
      next: (translations) => {
        this.translate.setTranslation(language, translations, true);
        this.translate.setDefaultLang(language);
        this.translate.use(language).subscribe(() => {
          localStorage.setItem('userLanguage', language);
        })
      },
      error: (err) => {
        console.error('Failed to load language file:', err);
      }
    });
  }


  updateUserLanguage(language: string) {
    if (!language) {
      language = 'en';
    }

    if (!this.translate.defaultLang) {
      this.translate.setDefaultLang('en');
    }

    if (this.translate.getLangs().length === 0) {
      this.translate.addLangs(['en', 'de', 'ar', 'fr', 'kannada']);
    }

    this.subscription = this.translate.use(language).subscribe(_ => {
      localStorage.setItem('userLanguage', language);
    });
  }


}
